<script>
import { PERSONAL_CONFIRM_IMAGE_AT } from '../../constants/constant'
export default {
  computed: {
    showSubIdentityType () {
      // 健康保険者 or マイナンバー のときは追加書類が必要
      return this.identity === '04' || this.identity === '05'
    },
    showProofNationalityType () {
      // 外国籍をもっているとき
      return this.nationality === '02'
    },
    displayIdentityLabel: function () {
      switch (this.identity) {
        case '01':
          return '運転免許証'
        case '02':
          return '運転経歴証明書'
        case '03':
          return 'パスポート'
        case '04':
          return '健康保険証'
        case '05':
          return 'マイナンバーカード（顔写真付き）'
        default:
          return ''
      }
    },
    displayFile1Label: function () {
      switch (this.identity) {
        case '01':
          return '運転免許証（表）'
        case '02':
          return '運転経歴証明書（表）'
        case '03':
          return 'パスポート(顔写真入り)'
        case '04':
          return '健康保険証（表）\n'
        case '05':
          return 'マイナンバーカード（顔写真付き）'
        default:
          return ''
      }
    },
    displayFile2Label: function () {
      switch (this.identity) {
        case '01':
          return '運転免許証（裏）'
        case '02':
          return '運転経歴証明書（裏）'
        case '03':
          return 'パスポート(所持人記入欄)'
        case '04':
          return '健康保険証（裏）\n'
        case '05':
          return ''
        default:
          return ''
      }
    },
    displaySecondFile1Label: function () {
      switch (this.secondIdentity) {
        case '01':
          return '運転免許証（表）'
        case '02':
          return '運転経歴証明書（表）'
        case '03':
          return 'パスポート(顔写真入り)'
        case '04':
          return '健康保険証（表）\n'
        case '05':
          return 'マイナンバーカード（顔写真付き）'
        case '06':
          return '住民票の写し（ファイル１）'
        case '07':
          return '公的書類'
        default:
          return ''
      }
    },
    displaySecondFile2Label: function () {
      switch (this.secondIdentity) {
        case '01':
          return '運転免許証（裏）'
        case '02':
          return '運転経歴証明書（裏）'
        case '03':
          return 'パスポート(所持人記入欄)'
        case '04':
          return '健康保険証（裏）\n'
        default:
          return ''
      }
    },
    displaySubIdentityLabel: function () {
      switch (this.subIdentity) {
        case '01':
          return '住民票の写し'
        case '02':
          return '公的書類'
        default:
          return ''
      }
    },
    displaySecondIdentityLabel: function () {
      switch (this.secondIdentity) {
        case '01':
          return '運転免許証'
        case '02':
          return '運転経歴証明書'
        case '03':
          return 'パスポート'
        case '04':
          return '健康保険証'
        case '05':
          return 'マイナンバーカード'
        case '06':
          return '住民票の写し'
        case '07':
          return '公的書類'
        default:
          return ''
      }
    },
    displayFile3Label: function () {
      switch (this.subIdentity) {
        case '01':
          return '住民票の写し（ファイル１）'
        case '02':
          return '公的書類'
        default:
          return ''
      }
    },
    displayProofNationalityLabel: function () {
      switch (this.proofNationality) {
        case '03':
          return '在留カード'
        case '04':
          return '特別永住者証明書'
        default:
          return ''
      }
    },
    displayFile4Label: function () {
      switch (this.proofNationality) {
        case '03':
          return '在留カード（表）'
        case '04':
          return '特別永住者証明書（表）'
        default:
          return ''
      }
    },
    displayFile5Label: function () {
      switch (this.proofNationality) {
        case '03':
          return '在留カード（裏）'
        case '04':
          return '特別永住者証明書（裏）'
        default:
          return ''
      }
    },
    displayFile6Label: function () {
      switch (this.subIdentity) {
        case '01':
          return '運転免許証'
        case '02':
          return '運転経歴証明書'
        case '03':
          return 'パスポート'
        case '04':
          return '健康保険証'
        case '05':
          return 'マイナンバーカード'
        case '06':
          return '住民票の写し'
        case '07':
          return '公的書類'
        default:
          return ''
      }
    }
  },
  methods: {
    goNextForTop () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        this.validateIdentity()
        this.validateSubIdentity()
        this.validateNationality()
        this.validateProofNationality()
        if (Object.keys(this.errors).length > 0) {
          this.isDisabled = false
          this.scrollTop()
          return
        }
        let queryParam = {
          identity: this.identity || '00',
          subIdentity: (this.identity === '04' || this.identity === '05') ? this.subIdentity : '00',
          secondIdentity: this.secondIdentity || '00',
          nationality: this.nationality || '02',
          proofNationality: this.nationality === '01' ? '00' : (this.proofNationality || '00')
        }
        this.$router.push({name: this.nextPageId, query: queryParam})
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    validateIdentity () {
      try {
        let reason = []
        if (this.identity) {
          if (['01', '02', '03', '04', '05'].indexOf(this.identity) === -1) {
            reason.push('unselect')
          }
        } else {
          reason.push('unselect')
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors['identity'] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    validateEnIdentity () {
      try {
        let reason = []
        if (this.identity) {
          if (['01', '02', '03', '04', '05'].indexOf(this.identity) === -1) {
            reason.push('unselect')
          }
        } else {
          reason.push('unselect')
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors['identity_en'] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    validateSubIdentity () {
      try {
        let reason = []
        if (this.identity && this.showSubIdentityType) {
          if (!this.subIdentity) {
            reason.push('unselect')
          } else {
            if (['01', '02'].indexOf(this.subIdentity) === -1) {
              reason.push('unselect')
            }
          }
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors['subIdentity'] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    validateSecondIdentity () {
      try {
        let label = ''
        let reason = []
        if (!this.secondIdentity) {
          label = 'secondIdentity'
          reason.push('unselect')
        } else {
          if (['01', '02', '03', '04', '05', '06', '07'].indexOf(this.secondIdentity) === -1) {
            label = 'secondIdentity'
            reason.push('unselect')
          } else if (this.identity === this.secondIdentity) {
            label = 'identity'
            reason.push('duplicated_identity')
          }
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors[label] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    validateNationality () {
      try {
        let reason = []
        if (this.nationality) {
          if (['01', '02'].indexOf(this.nationality) === -1) {
            reason.push('unselect')
          }
        } else {
          reason.push('unselect')
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors['nationality'] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    validateProofNationality: function () {
      try {
        let reason = []
        if (this.nationality && this.showProofNationalityType) {
          if (!this.proofNationality) {
            reason.push('unselect')
          } else {
            if (['03', '04'].indexOf(this.proofNationality) === -1) {
              reason.push('unselect')
            }
          }
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors['proofNationality'] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setImgFile1: function (fileData, fileName) {
      this.identifyFile.file_data1 = fileData
      this.identifyFile.file_name1 = fileName
      this.identifyFile.file_sbt1 = this.getIdentityFileSbt()
    },
    setImgFile2: function (fileData, fileName) {
      this.identifyFile.file_data2 = fileData
      this.identifyFile.file_name2 = fileName
      this.identifyFile.file_sbt2 = this.getIdentityFileSbt()
    },
    setImgFile3: function (fileData, fileName) {
      this.identifyFile.file_data3 = fileData
      this.identifyFile.file_name3 = fileName
      this.identifyFile.file_sbt3 = this.getSubIdentityFileSbt()
    },
    setImgFile4: function (fileData, fileName) {
      this.identifyFile.file_data4 = fileData
      this.identifyFile.file_name4 = fileName
      this.identifyFile.file_sbt4 = this.getNationalityFileSbt()
    },
    setImgFile5: function (fileData, fileName) {
      this.identifyFile.file_data5 = fileData
      this.identifyFile.file_name5 = fileName
      this.identifyFile.file_sbt5 = this.getNationalityFileSbt()
    },
    setSecondImgFile3: function (fileData, fileName) {
      this.identifyFile.file_data3 = fileData
      this.identifyFile.file_name3 = fileName
      this.identifyFile.file_sbt3 = this.getSecondIdentityFileSbt()
    },
    setSecondImgFile4: function (fileData, fileName) {
      this.identifyFile.file_data4 = fileData
      this.identifyFile.file_name4 = fileName
      this.identifyFile.file_sbt4 = this.getSecondIdentityFileSbt()
    },
    setSecondImgFile5: function (fileData, fileName) {
      this.identifyFile.file_data5 = fileData
      this.identifyFile.file_name5 = fileName
      this.identifyFile.file_sbt5 = this.getNationalityFileSbt()
    },
    setSecondImgFile6: function (fileData, fileName) {
      this.identifyFile.file_data6 = fileData
      this.identifyFile.file_name6 = fileName
      this.identifyFile.file_sbt6 = this.getNationalityFileSbt()
    },
    showError: function (error) {
      this.errors = error
    },
    getIdentityFileSbt () {
      // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
      switch (this.identity) {
        case '01':
          return '01'
        case '02':
          return '02'
        case '03':
          return '03'
        case '04':
          return '04'
        case '05':
          return '05'
        default:
          return ''
      }
    },
    getSubIdentityFileSbt () {
      // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
      switch (this.subIdentity) {
        case '01':
          return '08'
        case '02':
          return '09'
        default:
          return ''
      }
    },
    getSecondIdentityFileSbt () {
      // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
      switch (this.secondIdentity) {
        case '01':
          return '01'
        case '02':
          return '02'
        case '03':
          return '03'
        case '04':
          return '04'
        case '05':
          return '05'
        case '06':
          return '08'
        case '07':
          return '09'
        default:
          return ''
      }
    },
    getNationalityFileSbt () {
      // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
      switch (this.proofNationality) {
        case '03':
          return '06'
        case '04':
          return '07'
        default:
          return ''
      }
    },
    setPersonalConfirmImageAtCookie () {
      window.$cookies.set(PERSONAL_CONFIRM_IMAGE_AT, (new Date()).toJSON(), '15min', '/', null, process.env.COOKIES_SECURE)
    }
  },
  created () {
    try {
      if (window.$cookies.get(PERSONAL_CONFIRM_IMAGE_AT)) {
        this.goToErrorPage('Image upload prohibited')
      }
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/mixin/FileUpload.vue